var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeAce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#466dec;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.54 65.28 40.34 55.93 33.57 55.88 36.28 65.22 45.54 65.28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.25,49.84l14.89.1a3,3,0,0,1,2.6,1.54l8.54,15.38A3,3,0,0,1,53,70.23l-16.3,19.6a38.1,38.1,0,0,0,15.77,3.53c22.43.15,40.81-19.28,41-43.32S75.45,6.31,53,6.16,12.21,25.44,12,49.48c0,.1,0,.2,0,.3s.21,0,.31,0ZM49.9,23.48a3,3,0,1,1,6,0l-.16,23.27,20,.13a3,3,0,1,1,0,6l-23-.15a3,3,0,0,1-3-3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.48,90.27l.05-.21-.6-.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.37,71.22C35,76.9,33.86,81.36,33,84.86L44.3,71.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.7,52.77l23,.15a3,3,0,1,0,0-6l-20-.13.16-23.27a3,3,0,1,0-6,0l-.18,26.27A3,3,0,0,0,52.7,52.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.06.16C27.32,0,6.23,22.09,6,49.44a53.61,53.61,0,0,0,.48,7.43L1,66.51a3,3,0,0,0,.27,3.38L24.6,98.73h0a3,3,0,0,0,.4.4h0l0,0,.17.12.23.16.12,0,.19.09.21.09h0l.17,0,.15,0,.1,0a3.88,3.88,0,0,0,.48,0,2.63,2.63,0,0,0,.49,0l.1,0,.15,0,.22,0,.19-.08h0l.15-.07a.31.31,0,0,0,.1-.05l.18-.1.21-.14.07,0,0,0,.07-.07a3.57,3.57,0,0,0,.28-.27.46.46,0,0,1,.07-.07l3.48-4.18a44.23,44.23,0,0,0,19.67,4.78c25.74.17,46.83-21.94,47-49.28S78.8.34,53.06.16ZM25.48,90.27l-.55-.67L11.44,72.93,7.22,67.71l1.25-2.18L12.77,58l1.31-2.27,13.13.09h.1L30,65.18,18.5,65.1a3,3,0,0,0-2.95,2.36q.69,1.67,1.5,3.27a3,3,0,0,0,1.41.37l11.74.08c-.89,3.61-2,8.2-3.08,12.45l-1.59,6.43Zm10.89-19,7.93,0L33,84.86C33.86,81.36,35,76.9,36.37,71.22Zm-2.8-15.34,6.77,0,5.2,9.35-9.26-.06ZM52.43,93.36a38.1,38.1,0,0,1-15.77-3.53L53,70.23a3,3,0,0,0,.32-3.37L44.74,51.48a3,3,0,0,0-2.6-1.54l-14.89-.1-14.89-.1c-.1,0-.21,0-.31,0s0-.2,0-.3C12.21,25.44,30.59,6,53,6.16S93.57,26,93.41,50,74.86,93.51,52.43,93.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.05,70.73q-.81-1.61-1.5-3.27a2.56,2.56,0,0,0-.07.62A3,3,0,0,0,17.05,70.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeAce);
export default __webpack_public_path__ + "static/media/TimeAce.6204727c8f6a18339093e45952d5b0e2.svg";
export { ForwardRef as ReactComponent };